import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import { useAuth } from '../context/AuthContext';
import '../styles/Membres.css';

const Connexion = () => {
  const { connexion } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [resetMsg, setResetMsg] = useState('');
  const [isResetting, setIsResetting] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setResetMsg('');
    try {
      await connexion(email, password);
      navigate('/espace-membres');
    } catch (err) {
      setError('Email ou mot de passe incorrect.');
    }
  };

  const handleForgotPassword = async () => {
    setError('');
    setResetMsg('');

    if (!email.trim()) {
      setError("Veuillez d'abord saisir votre adresse e-mail ci-dessus.");
      return;
    }

    setIsResetting(true);
    const { error: resetError } = await supabase.auth.resetPasswordForEmail(email.trim(), {
      redirectTo: 'https://zineuvitables.org/reinitialisation-mot-de-passe',
    });
    setIsResetting(false);

    if (resetError) {
      setError("Erreur lors de l'envoi de l'e-mail : " + resetError.message);
    } else {
      setResetMsg("Un e-mail de réinitialisation a été envoyé à l'adresse indiquée ! 📧");
    }
  };

  return (
    <div className="membres-container">
      <h2>Connexion à l'espace membres</h2>
      <form onSubmit={handleSubmit} className="membres-form">
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Mot de passe"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        {error && <p className="membres-error">{error}</p>}
        {resetMsg && <p style={{ color: '#28a745', fontSize: '0.9rem', marginTop: '10px' }}>{resetMsg}</p>}

        <button type="submit" className="membres-btn">Se connecter</button>
      </form>

      <div style={{ marginTop: '15px', textAlign: 'center' }}>
        <button
          type="button"
          onClick={handleForgotPassword}
          disabled={isResetting}
          style={{
            background: 'none',
            border: 'none',
            color: '#007bff',
            textDecoration: 'underline',
            cursor: 'pointer',
            fontSize: '0.9rem',
          }}
        >
          {isResetting ? 'Envoi en cours...' : 'Mot de passe oublié ?'}
        </button>
      </div>

      <p style={{ marginTop: '15px' }}>
        Pas encore de compte ? <Link to="/inscription">S'inscrire</Link>
      </p>
    </div>
  );
};

export default Connexion;